module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./packages/layout/node_modules/babel-runtime/core-js/object/assign.js
// module id = 187
// module chunks = 0